import { inject, Injectable, signal } from '@angular/core';
import { AndroidLifecycle, NgxHybridService } from '@digipay/ngx-hybrid-service';
import { StorageService } from '@client-monorepo/common/utilities';
import { TacService } from './tac.service';

@Injectable({
  providedIn: 'root',
})
/**
 * This service is used to track the user's idle time when the app is moved to the background
 * and to prompt the user to enter their PIN upon returning.
 **/
export class IdleTrackerService {
  private ngxHybridService = inject(NgxHybridService);
  private storageService = inject(StorageService);
  private tacService = inject(TacService);

  private readonly idleLimit = signal<number>(3 * 60 * 1000); // 3 minutes

  public observeAppStateChange(): void {
    this.ngxHybridService.getLifeCycleStatus().subscribe({
      next: (state) => {
        if (state == AndroidLifecycle.ON_PAUSE) {
          this.onAppGoesToBackground();
        }
        if (state == AndroidLifecycle.ON_RESUME) {
          this.onAppComesToForeground();
        }
      },
    });
  }
  private onAppGoesToBackground(): void {
    const currentTime = Date.now();
    this.storageService.setTimeStamp(currentTime);
  }

  private onAppComesToForeground() {
    const now = Date.now();
    const savedTime = this.storageService.getTimeStamp();

    if (!savedTime) return;

    const elapsed = now - parseInt(savedTime, 10);

    if (elapsed >= this.idleLimit()) {
      this.tacService.getTac();
    }
  }
}
